import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { Tabs, Tab } from '../../shared/tabs.component';

import ProposedSubledgerJournalGrid, { slJournalPropTypes } from '../common/proposedSubledgerJournalGrid.component';
import ProposedSubledgerBalanceGrid, { slDeferredBalancePropTypes } from '../common/proposedSubledgerBalanceGrid.component';

export const proposedReclassJournalsPropTypes = PropTypes.arrayOf(PropTypes.shape({
  slJournal: slJournalPropTypes,
  slBalance: slDeferredBalancePropTypes,
}));

const TabTypes = {
  FROM_SL_JOURNAL: 'FROM_SL_JOURNAL',
  FROM_SL_BALANCE: 'FROM_SL_BALANCE',
  TO_SL_JOURNAL: 'TO_SL_JOURNAL',
  TO_SL_BALANCE: 'TO_SL_BALANCE',
};

class ViewJournalGrids extends PureComponent {
  static propTypes = {
    proposedJournals: proposedReclassJournalsPropTypes,
  };

  state = {
    activeTab: TabTypes.FROM_SL_JOURNAL,
  };

  changeTab = (event, tabType) => {
    this.setState({
      activeTab: tabType,
    });
  };

  render() {
    const { activeTab } = this.state;

    const [fromJournals, toJournals] = this.props.proposedJournals;

    const fromSlJournal = fromJournals ? fromJournals.slJournal : null;
    const fromSlBalance = fromJournals ? fromJournals.slDeferredBalance : null;
    const toSlJournal = toJournals ? toJournals.slJournal : null;
    const toSlBalance = toJournals ? toJournals.slDeferredBalance : null;

    return (
      <div className="view-journal-grids page-content-container">
        <Tabs
          defaultValue={TabTypes.FROM_SL_JOURNAL}
          value={activeTab}
          onChange={this.changeTab}
          className="a-tab-bar-margin-10"
          size="md"
        >
          <Tab value={TabTypes.FROM_SL_JOURNAL} label="From Proposed Subledger Journals">
            {fromSlJournal ? (
              <ProposedSubledgerJournalGrid
                slJournal={fromSlJournal}
                allowGross={fromJournals.allowGross}
              />
            ) : 'No Subledger Journals Available'}
          </Tab>

          <Tab value={TabTypes.FROM_SL_BALANCE} label="From Proposed Subledger Balances">
            {fromSlBalance ? (
              <ProposedSubledgerBalanceGrid
                slDeferredBalance={fromSlBalance}
                allowGross={fromJournals.allowGross}
              />
            ) : 'No Subledger Balances Available'}
          </Tab>

          <Tab value={TabTypes.TO_SL_JOURNAL} label="To Proposed Subledger Journals">
            {toSlJournal ? (
              <ProposedSubledgerJournalGrid
                slJournal={toSlJournal}
                allowGross={toJournals.allowGross}
              />
            ) : 'No Subledger Journals Available'}
          </Tab>

          <Tab value={TabTypes.TO_SL_BALANCE} label="To Proposed Subledger Balances">
            {toSlBalance ? (
              <ProposedSubledgerBalanceGrid
                slDeferredBalance={toSlBalance}
                allowGross={toJournals.allowGross}
              />
            ) : 'No Subledger Balances Available'}
          </Tab>
        </Tabs>
      </div>
    );
  }
}

export default ViewJournalGrids;
